module.exports = __webpack_public_path__ + "img/导航背景.99b87001.png";